import React from "react";

const reportStatuses = [
  {
    label: "Final",
    value: "final",
  },
  {
    label: "In progress",
    value: "inProgress",
  },
];

const ReportStatus = ({ labReportFormData, handleChange }) => {
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center gap-4">
          <h4 className="mb-4">Report Status :</h4>

          <div className="form-group d-flex align-items-center gap-4">
            {reportStatuses.map((status) => (
              <div className="form-check me-3" key={status.value}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="labReportStatus"
                  id={status.value}
                  value={status.value}
                  checked={labReportFormData.labReportStatus === status.value}
                  onChange={handleChange}
                />

                <label
                  className="form-check-label"
                  htmlFor={status.value}
                >
                  {status.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportStatus;